import React from 'react';

const AverageCost = React.createContext();

export default AverageCost;
